import { uuidv4 } from "../../common";
export class FabricObject {
    constructor(args) {
        this.dirty = false;
        this.added = false;
        this.uuid = uuidv4();
        const keys = Object.keys(args);
        keys.forEach((key) => this[key] = args[key]);
    }
    set(propName, value) {
        this[propName] = value;
        return this;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    draw(ctx, scale) {
    }
}
//# sourceMappingURL=FabricObject.js.map